// 导入组件
import Vue from 'vue';
import Router from 'vue-router';
// 登录
import login from '@/views/login';
import index from '@/views/index';
//首页
import Home from '@/views/home/index';
import Supervise from '@/views/supervise/index';
import Manager from '@/views/auth/manager';
import Device from '@/views/device/index';
import Group from '@/views/device/group';

import Notice from '@/views/notice/index';
import White from '@/views/auth/white';
import Spread from '@/views/Spread/Spread';
import Task from '@/views/task/index';
import Current from '@/views/alarm/current';
import protocal from '@/views/protocal/protocal';
import course from '@/views/course/course';
import Alarm from '@/views/alarm/alarm';
import User from '@/views/user/index';
import Phone from '@/views/user/phone';
import Repair from '@/views/repair/index';

/**
 * 数据监控
 */
// 监控查询

// 启用路由
Vue.use(Router);

// 导出路由
export default new Router({
    routes: [
        {
            path: '/',
            name: '',
            component: login,
            hidden: true,
            meta: {
                requireAuth: false
            }
        },
        {
            path: '/login',
            name: '登录',
            component: login,
            hidden: true,
            meta: {
                requireAuth: false
            }
        },
        {
            path: '/index',
            name: '首页',
            component: index,
            iconCls: 'el-icon-tickets',
            children: [
                {
                    path: '/home/index',
                    name: '首页',
                    component: Home,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: '/supervise/index',
                    name: '监控平台',
                    component: Supervise,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: '/auth/manager',
                    name: '管理员管理',
                    component: Manager,
                    meta: {
                        requireAuth: true
                    }
                }, {
                    path: '/device/index',
                    name: '设备列表',
                    component: Device,
                    meta: {
                        requireAuth: true
                    }
                }, {
                    path: '/device/group',
                    name: '分组列表',
                    component: Group,
                    meta: {
                        requireAuth: true
                    }
                }, {
                    path: '/notice/index',
                    name: '系统公告',
                    component: Notice,
                    meta: {
                        requireAuth: true
                    }
                }, {
                    path: '/auth/white',
                    name: '管理员白名单',
                    component: White,
                    meta: {
                        requireAuth: true
                    }
                }, {
                    path: '/spread/index',
                    name: '设备分布',
                    component: Spread,
                    meta: {
                        requireAuth: true
                    }
                }, {
                    path: '/task/index',
                    name: '任务列表',
                    component: Task,
                    meta: {
                        requireAuth: true
                    }
                }, {
                    path: '/alarm/current',
                    name: '当前报警',
                    component: Current,
                    meta: {
                        requireAuth: true
                    }
                }, {
                    path: '/alarm/index',
                    name: '历史报警',
                    component: Alarm,
                    meta: {
                        requireAuth: true
                    }
                }, {
                    path: '/protocal/index',
                    name: '协议列表',
                    component: protocal,
                    meta: {
                        requireAuth: true
                    }
                }, {
                    path: '/course/index',
                    name: '教程列表',
                    component: course,
                    meta: {
                        requireAuth: true
                    }
                }, {
                    path: '/user/index',
                    name: '人员管理',
                    component: User,
                    meta: {
                        requireAuth: true
                    }
                }, {
                    path: '/user/phone',
                    name: '更改电话',
                    component: Phone,
                    meta: {
                        requireAuth: true
                    }
                }, {
                    path: '/repair/index',
                    name: '维修/保养',
                    component: Repair,
                    meta: {
                        requireAuth: true
                    }
                }
            ]
        }]
})



// WEBPACK FOOTER //
// ./src/router/index.js